import React, { useMemo } from 'react';
import { ApolloError } from '@apollo/client';

import { PointExpirationScheduleFragment } from '@occc/graphql';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { IPaginationProps } from '@occc/ui-design-system';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { DataTable, Row } from '@occc/ui-design-system';

import { pointExpirationScheduleTableMessages as messages } from './point-expiration-schedule-table.messages';
import { makeFields } from './point-expiration-schedule-table.utils';

const headers = [
  { label: messages.expirationDate },
  { label: messages.points, align: 'right' as const },
];

type PointExpirationScheduleTableProps = {
  pointExpirations?: PointExpirationScheduleFragment[] | null;
  paginationProps?: IPaginationProps;
  loading?: boolean;
  error?: ApolloError;
};

export const PointExpirationScheduleTable = (props: PointExpirationScheduleTableProps) => {
  const { pointExpirations = [], paginationProps, loading = false, error } = props;

  const rows = useMemo<Row[] | null | undefined>(() => {
    return pointExpirations?.map((pointExpiration) => ({
      key: pointExpiration.date,
      fields: makeFields(pointExpiration),
    }));
  }, [pointExpirations]);

  return (
    <DataTable
      headers={headers}
      rows={rows}
      loading={loading}
      error={error}
      paginationProps={paginationProps}
    />
  );
};
